import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  display: ${props => props.isVisible ? 'block': 'none'};
  width: 100%;
  height: 380px;
  padding-top: 60px;
  img {
    width: 172px;
    height: 134px;
    display: block;
    margin: auto;
    margin-top: 100px;
  }
  p {
    font-family: Overpass;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    color: #444053;
  }
`;

const Empty = ({ text, isVisible }) => {
  return (
    <Wrapper isVisible={isVisible}>
      <img src="/images/empty.svg" alt="empty"/>
      <p>{text || 'No items found'}</p>
    </Wrapper>
  )
}

export default Empty
